import axios from 'axios';
import * as apiURL from './apiConfig';

export const getRecommendations = async () => {
  try {
    const response = await axios.get(apiURL.RECOMMENDATIONS_URL);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
